/* eslint-disable no-inner-declarations */
import { DatabaseAdapter } from '@/configuration';
import { getFunctionsOnContext } from '@/constants';
import log from 'loglevel';

export async function initializeChat({ commitChatMessage, commitChatState, commitConversationID, commitLockStatus, commitLoadStatus, bot_id, data, simulator_mode }) {
  try {
    
    const processChatMessage = commitChatMessage;
    const processChatState = commitChatState;
    const processConversationID = commitConversationID;
    const processLockStatus = commitLockStatus;
    const processLoadStatus = commitLoadStatus;


    let conversation_id = localStorage.getItem('conversation_id');

    if(!conversation_id){
      conversation_id = (await DatabaseAdapter.callCloudFunction(getFunctionsOnContext().START_CHAT, {bot_id, data, simulator_mode})).conversation_id;
      localStorage.setItem('conversation_id', conversation_id);
    }
    
    
    if(!conversation_id){ throw Error("sem conv id") }

    processConversationID({conversation_id});

    await DatabaseAdapter.subscribeToMessages({processChatMessage, bot_id, conversation_id });
    await DatabaseAdapter.subscribeToLock({processLockStatus, bot_id, conversation_id});
    await DatabaseAdapter.subscribeToLoad({processLoadStatus, bot_id, conversation_id});
    await DatabaseAdapter.subscribeToState({processChatState, bot_id, conversation_id});
  
  }
   catch (error) {
    log.error(`use_case.initializeChat ERROR`, error);
    Promise.reject()
    throw Error("use_case.initializeChat ERROR")  
    
  }
}
